import BaseService from './../base'

export default class TradingDeskService extends BaseService {
  static resource() {
    return 'api/v1/external/tradingDesks'
  }
}
